(() => {
  const configNode = document.getElementById('wrld-retailer-deposit-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const propertyName = 'WRLD pre-order acknowledgment';
  const checkoutSelector = '#wsg-go-to-shipping-address, #wsg-checkout-two, button[name="checkout"], input[name="checkout"], a[href^="/checkout"]';
  let resuming = false;
  let pending = false;
  let panel;

  const isWrld = item => String(item.variant_id || item.id) === String(config.variantId);
  const accepted = item => item.properties && item.properties[propertyName] === config.acknowledgment;

  async function getCart() {
    const response = await fetch(config.cartPath, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(config.saveError);
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error(config.saveError);
    return cart;
  }

  function create(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function showPanel(control, message, allowAcknowledge, checkoutForm) {
    if (panel) panel.remove();
    panel = create('section', 'wrld-deposit-cart-guard');
    panel.setAttribute('aria-label', config.cartHeading);
    panel.append(create('h2', '', config.cartHeading));
    panel.append(create('p', '', config.shippingDetail));
    const error = create('p', 'wrld-deposit-error', message || '');
    error.setAttribute('role', 'alert');
    panel.append(error);
    if (allowAcknowledge) {
      const wrapper = create('div', 'wrld-deposit-ack');
      const label = create('label');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.required = true;
      checkbox.setAttribute('aria-required', 'true');
      label.append(checkbox, create('span', '', config.acknowledgment));
      wrapper.append(label, create('p', 'wrld-deposit-ack-hint', config.invoiceNotice));
      panel.append(wrapper);
      const button = create('button', 'wrld-deposit-continue', config.continueLabel);
      button.type = 'button';
      button.addEventListener('click', async () => {
        if (!checkbox.checked) {
          error.textContent = config.ackError;
          checkbox.focus();
          return;
        }
        button.disabled = true;
        button.textContent = config.savingLabel;
        try {
          const cart = await getCart();
          const lines = cart.items.filter(isWrld);
          if (!config.authorized || cart.items.some(item => !isWrld(item)) || !lines.length) throw new Error(config.mixedCart);
          const originalQuantity = lines.reduce((sum, item) => sum + item.quantity, 0);
          let current = cart;
          for (let attempt = 0; attempt < lines.length; attempt += 1) {
            const item = current.items.find(line => isWrld(line) && !accepted(line));
            if (!item) break;
            const response = await fetch(config.changePath, {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', Accept: 'application/json'},
              body: JSON.stringify({id: item.key, quantity: item.quantity, properties: {...item.properties, [propertyName]: config.acknowledgment}})
            });
            if (!response.ok) throw new Error(config.saveError);
            current = await getCart();
            if (current.items.some(line => !isWrld(line))) throw new Error(config.mixedCart);
          }
          const verified = await getCart();
          if (verified.items.some(item => !isWrld(item)) || verified.items.some(item => !accepted(item)) || verified.items.reduce((sum, item) => sum + item.quantity, 0) !== originalQuantity) throw new Error(config.saveError);
          panel.remove();
          panel = null;
          resume(control, checkoutForm);
        } catch (errorValue) {
          error.textContent = errorValue.message || config.saveError;
          button.disabled = false;
          button.textContent = config.continueLabel;
        }
      });
      panel.append(button);
    }
    if (control && control.parentElement) control.parentElement.insertBefore(panel, control);
    else (document.querySelector('main') || document.body).prepend(panel);
    panel.scrollIntoView({behavior: 'smooth', block: 'center'});
    const focusTarget = panel.querySelector('input');
    if (focusTarget) focusTarget.focus({preventScroll: true});
  }

  function resume(control, checkoutForm) {
    if (!control || !control.isConnected) return;
    resuming = true;
    try {
      if (checkoutForm) checkoutForm.requestSubmit(control);
      else control.click();
    } finally {
      resuming = false;
    }
  }

  async function checkCheckout(control, checkoutForm) {
    if (pending) return;
    pending = true;
    try {
      const cart = await getCart();
      const wrld = cart.items.filter(isWrld);
      if (!wrld.length) {
        resume(control, checkoutForm);
      } else if (!config.authorized) {
        showPanel(control, config.loginRequired, false);
      } else if (cart.items.some(item => !isWrld(item))) {
        showPanel(control, config.mixedCart, false);
      } else if (wrld.every(accepted)) {
        resume(control, checkoutForm);
      } else {
        showPanel(control, config.ackError, true, checkoutForm);
      }
    } catch (error) {
      showPanel(control, config.saveError, false);
    } finally {
      pending = false;
    }
  }

  document.addEventListener('click', event => {
    if (resuming) return;
    const control = event.target instanceof Element ? event.target.closest(checkoutSelector) : null;
    if (!control || control.closest('.wrld-deposit-cart-guard')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkCheckout(control);
  }, true);

  document.addEventListener('submit', event => {
    if (resuming) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const checkoutControl = event.submitter;
    if (checkoutControl && checkoutControl.matches(checkoutSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkCheckout(checkoutControl, form);
      return;
    }
    const input = form.querySelector('[name="id"]');
    if (!input || String(input.value) !== String(config.variantId)) return;
    const checkbox = [...document.querySelectorAll('[data-wrld-deposit-ack]')].find(item => item.form === form);
    if (config.authorized && checkbox && checkbox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!config.authorized) {
      showPanel(form, config.loginRequired, false);
    } else if (checkbox) {
      const error = checkbox.closest('.input-wrapper').querySelector('.input-error-container');
      if (error) error.textContent = config.ackError;
      checkbox.focus();
    } else {
      location.assign(config.productPath);
    }
  }, true);

  function markQuickOrderRows() {
    for (const row of document.querySelectorAll('.wsg-variant-row')) {
      const sku = row.querySelector('.wsg-sku-full, .wsg-sku-text');
      const link = row.querySelector(`a[href*="${config.productPath}"]`);
      if (!link && (!sku || sku.textContent.trim() !== config.sku)) continue;
      for (const input of row.querySelectorAll('.wsg-qty-area input[type="number"], input.quantity')) input.disabled = true;
      for (const control of row.querySelectorAll('.wsg-dec, .wsg-inc')) {
        control.setAttribute('aria-disabled', 'true');
        control.style.pointerEvents = 'none';
      }
      if (!row.querySelector('.wrld-deposit-quick-review')) {
        const note = create('div', 'wrld-deposit-quick-review', config.depositLabel);
        const linkNode = create('a', 'wrld-deposit-review-link', config.reviewLabel);
        linkNode.href = config.productPath;
        note.append(document.createElement('br'), linkNode);
        (row.querySelector('.wsg-qty-area') || row).append(note);
      }
    }
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      markQuickOrderRows();
    });
  });
  markQuickOrderRows();
  observer.observe(document.body, {childList: true, subtree: true});
})();
